"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _keyframes = require("./keyframes");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    position: absolute;\n    background-color: inherit;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    width: 10%;\n    border-radius: 2px;\n    transform: scaleX(0);\n    height: 100%;\n    background: ", ";\n    animation: ", " 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.05s infinite;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Short = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.theme.progressColor;
}, _keyframes["short"]);

var _default = Short;
exports["default"] = _default;